module.exports = __webpack_public_path__ + "img/Kenya.9da286d5.svg";